/* eslint-disable max-len */
/* eslint-disable eqeqeq */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Col,
  Form,
  Input,
  message,
  Spin,
  Tooltip,
  Typography,
} from 'antd';
import {
  getDistinctValues,
  listToString,
  toFixed,
  toInteger,
} from 'utils/normalizers';
import Select from 'components/Select';
import { LinkOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Uploader from 'components/Uploader';
// eslint-disable-next-line import/no-extraneous-dependencies
import { read, utils } from 'xlsx';
import {
  getEdificiosDePredios,
  getEtapasDePredios,
  getManzanasDePredios,
  getTipoDePredio,
  getTiposDePrediosUrbanos,
  getUnidadesDePredios,
  getValoresDeTerrenosYConstrucciones,
} from 'api/catastro';
import { getTiposDeVialidades } from 'api/usuarios';
import { useSelector } from 'react-redux';
import { getCodigosPostales } from 'api/catalogos';
import { formatValoresPredio } from 'api/catastro/predio';

const DEV = process.env.NODE_ENV === 'development';

const gettersByFkFieldName = {
  edificio_id: (clave) => getEdificiosDePredios({ clave }),
  unidad_id: (clave) => getUnidadesDePredios({ clave }),
  manzana_id: (clave) => getManzanasDePredios({ clave }),
  etapa_id: (clave) => getEtapasDePredios({ clave }),
  tipo_de_predio_id: (clave) => getTipoDePredio({ clave }),
  tipo_de_predio_urbano_id: (clave) => getTiposDePrediosUrbanos({ clave }),
  'direccion.tipo_de_vialidad_id': (descripcion) => getTiposDeVialidades({ descripcion }),
  'direccion.codigo_postal_id': (q) => getCodigosPostales({
    d_asenta: q.split('_')[0],
    d_codigo: q.split('_')[1] || undefined,
    municipio: 633,
  }),
};
const booleanFields = ['tasa_baldio', 'predio_con_accesorios'];
const not_found_fk = 'not_found_fk';

const Subdivision = ({
  disabled,
  tramites,
  cantidad: _cantidad,
  cantidadMaxima,
  requierePreguntarHeredarCampos,
  cargaExcel = true,
  observaciones_subdivision,
  observaciones_cancelacion,
  aplicaObservacionCancelacion,
  predio,
}) => {
  const entidad = useSelector((s) => s.auth.entidad);
  const form = Form.useFormInstance();
  const archivo = Form.useWatch('archivo', form);
  const cantidad = Form.useWatch('cantidad', form);
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);

  const parseFile = async (workbook) => {
    const options = { range: 1, blankrows: false, defval: null };
    const _predios = utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], options);
    if (_predios.length !== cantidad) {
      message.warning(`La cantidad de predios en el archivo (${_predios.length}) no concuerda con la cantidad específicada (${cantidad})`);
      form.resetFields(['archivo']);
      return;
    }
    setLoading(true);
    const terrenos = utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[1]], options);
    const construcciones = utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[2]], options);
    const areasComunes = utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[3]], options);
    const referidos = utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[4]], options);
    const keysPredio = Object.keys(_predios[0]).filter((k) => !k.startsWith('__EMPTY'));
    const fkFields = keysPredio.filter((k) => k.endsWith('_id'));
    const distinctQsMatrix = fkFields.map((fk) => _predios.map((_predio) => {
      if (fk === 'direccion.codigo_postal_id' && _predio[fk]) {
        return `${_predio[fk]}_${_predio['direccion.cp_texto'] || ''}`;
      }
      return _predio[fk];
    })).map((arr) => getDistinctValues(arr).filter((e) => e));
    const distinctIndexedQsMatrix = (await Promise.all(
      fkFields.map((fk, idx) => Promise.all(distinctQsMatrix[idx].map(
        (q) => gettersByFkFieldName[fk](q),
      ))),
    )).map((res) => {
      if (res.some((r) => r.results)) return res.map((e) => e.results).flat(2);
      return res.flat();
    });
    const distinctValores = getDistinctValues([
      ...terrenos.map((t) => `${t.matriz_bloque}_${t.valor_unitario}_${t.anio}_${true}`),
      ...construcciones.map((t) => `${t.matriz_bloque}_${t.valor_unitario}_${t.anio}_${false}`),
    ]).filter((e) => !e.includes('null'));
    const valores = (await Promise.all(distinctValores.map((matrizValor) => {
      const [matriz_valor, valor, anio, tipo_bloque] = matrizValor.split('_');
      return getValoresDeTerrenosYConstrucciones({
        matriz_valor,
        valor,
        anio,
        tipo_bloque,
      });
    }))).flat();
    const _errors = {
      construcciones: [],
      terrenos: [],
      predios: _predios.map(({ clave_catastral_municipal, __rowNum__ }) => ({
        clave_catastral_municipal,
        row: __rowNum__ + 1,
        errors: [],
      })),
    };

    terrenos.forEach((terreno, index) => {
      terrenos[index].valor_id = valores.find((v) => v.valor == terreno.valor_unitario
        && v.matriz_valor == terreno.matriz_bloque)?.id || not_found_fk;
      if (terrenos[index].valor_id === not_found_fk) {
        _errors.terrenos.push(terreno.__rowNum__ + 1);
      }
    });
    construcciones.forEach((terreno, index) => {
      construcciones[index].valor_id = valores.find((v) => v.valor == terreno.valor_unitario
        && v.matriz_valor == terreno.matriz_bloque)?.id || not_found_fk;
      if (construcciones[index].valor_id === not_found_fk) {
        _errors.construcciones.push(terreno.__rowNum__ + 1);
      }
    });
    areasComunes.forEach((item, index) => {
      Object.keys(item).filter((k) => k.startsWith('__EMPTY')).forEach((key) => {
        delete areasComunes[index][key];
      });
      areasComunes[index].tipo_de_bloque_area_comun = item.tipo_de_bloque_area_comun === 'T';
    });
    referidos.forEach((item, index) => {
      Object.keys(item).filter((k) => k.startsWith('__EMPTY')).forEach((key) => {
        delete referidos[index][key];
      });
    });

    const predios = [];
    _predios.forEach((_predio, predioIndex) => {
      const normalized = {};
      normalized.direccion = {
        // codigo_postal_id: predio.direccion?.codigo_postal || not_found_fk,
        tipo_de_vialidad_id: 5, // calle
      };
      keysPredio.forEach((key) => {
        if (fkFields.includes(key) && _predio[key]) {
          const fkIndex = fkFields.indexOf(key);
          const qIndex = distinctQsMatrix[fkIndex].indexOf(key === 'direccion.codigo_postal_id'
            ? `${_predio[key]}_${_predio['direccion.cp_texto'] || ''}` : _predio[key]);
          const val = distinctIndexedQsMatrix[fkIndex][qIndex]?.id || not_found_fk;
          if (val === not_found_fk) _errors.predios[predioIndex].errors.push(key);
          if (key.startsWith('direccion.')) {
            normalized.direccion[key.replace('direccion.', '')] = val;
          } else {
            normalized[key] = val;
          }
        } else if (booleanFields.includes(key)) {
          normalized[key] = _predio[key] === 'T';
        } else if (key.startsWith('direccion.')) {
          const _key = key.replace('direccion.', '');
          normalized.direccion[_key] = normalized.direccion[_key] || _predio[key];
        } else if (!key.startsWith('desde_') && !key.startsWith('hasta_')) {
          normalized[key] = _predio[key];
        }
        if (key === 'tipo_de_vialidad_id' && !normalized[key]) {
          normalized[key] = 5; // calle
        }
      });
      if (_predio['direccion.colonia_texto'] && !_predio['direccion.codigo_postal_id']) {
        normalized.direccion.codigo_postal_id = 58869;
      }
      const {
        desde_terreno,
        hasta_terreno,
        desde_construccion,
        hasta_construccion,
        desde_areas,
        hasta_areas,
        desde_valores,
        hasta_valores,
      } = _predio;
      const filter = (from, to) => (t) => from && to
        && t.__rowNum__ + 1 >= from && t.__rowNum__ + 1 <= to;
      const normalizeBloque = (bloque) => {
        const valor_unitario = toFixed(bloque.valor_unitario, 3);
        const area = toFixed(bloque.area, 3);
        const factor_ajuste = toFixed(bloque.factor_ajuste, 3);
        return {
          ...bloque,
          valor_unitario,
          area,
          factor_ajuste,
          importe: toFixed(valor_unitario * area * factor_ajuste, 3),
        };
      };
      normalized.terrenos = terrenos.filter(filter(desde_terreno, hasta_terreno))
        .map((terreno) => ({
          ...normalizeBloque(terreno),
          tipo_de_bloque: true,
        }));
      normalized.construcciones = construcciones
        .filter(filter(desde_construccion, hasta_construccion))
        .map((construccion) => ({
          ...normalizeBloque(construccion),
          tipo_de_bloque: false,
        }));
      normalized.areas_comunes = areasComunes.filter(filter(desde_areas, hasta_areas));
      normalized.valores_referidos = referidos.filter(filter(desde_valores, hasta_valores));
      normalized.bloques_terreno_construccion = [...normalized.terrenos, ...normalized.construcciones];

      predios[predioIndex] = normalized;
      _errors.predios[predioIndex].errors = listToString(_errors.predios[predioIndex].errors);
    });
    _errors.terrenos = listToString(getDistinctValues(_errors.terrenos));
    _errors.construcciones = listToString(getDistinctValues(_errors.construcciones));
    _errors.predios = _errors.predios.filter((p) => p.errors);
    const reduce = (arr, key) => arr.reduce((accum, curr) => accum + toFixed(curr[key], 3), 0);
    predios.forEach((_, index) => {
      const { terrenos: _terrenos, construcciones: _construcciones } = predios[index];
      const valoresPredio = formatValoresPredio(predios[index]);
      predios[index] = { ...predios[index], ...valoresPredio };
      predios[index].valor_del_terreno = toFixed(reduce(_terrenos, 'importe'), 3)
        || valoresPredio.valor_del_terreno;
      predios[index].superficie_total_del_terreno = toFixed(reduce(_terrenos, 'area'), 3)
        || valoresPredio.superficie_total_del_terreno;
      predios[index].valor_de_la_construccion = toFixed(reduce(_construcciones, 'importe'), 3)
        || valoresPredio.valor_de_la_construccion;
      predios[index].superficie_de_la_construccion = toFixed(reduce(_construcciones, 'area'), 3)
        || valoresPredio.superficie_de_la_construccion;
      predios[index].valor_catastral = (predios[index].valor_del_terreno + predios[index].valor_de_la_construccion)
        || valoresPredio.valor_catastral;
      delete predios[index].terrenos;
      delete predios[index].construcciones;

      predios[index].descripcion = predios[index].descripcion || 'General';
      predios[index].entidad_id = entidad.id;
      predios[index].estados_globales_id = 2;
      predios[index].uso_de_predio_id = predios[index].uso_de_predio_id || predio.uso_de_predio;
      predios[index].contribuyente_id = predios[index].contribuyente_id
        || predio.contribuyente?.id || predio.contribuyente;
      predios[index].ciudadano_id = predios[index].ciudadano_id
        || predio.ciudadano?.id || predio.ciudadano;
      predios[index].nombre_propietario = predios[index].nombre_propietario || predio.nombre_propietario;
      predios[index].nombre_completo = predios[index].nombre_completo || predio.nombre_completo;
      predios[index].participe_principal = predios[index].participe_principal || predio.participe_principal;
      predios[index].apellido_paterno_propietario = predios[index].apellido_paterno_propietario
        || predio.apellido_paterno_propietario;
      predios[index].apellido_materno_propietario = predios[index].apellido_materno_propietario
        || predio.apellido_materno_propietario;
      predios[index].subdivision_id = predio.id;
      predios[index].participes = predio.participes.map((participe) => ({
        apellido_materno: participe.apellido_materno,
        apellido_paterno: participe.apellido_paterno,
        descripcion: participe.descripcion,
        es_participe_principal: participe.es_participe_principal,
        nombre_participe: participe.nombre_participe,
        porcentaje: participe.porcentaje,
        porcentaje_nuevo: participe.porcentaje_nuevo,
        object_id_participe: participe.object_id_participe,
        entidad_id: entidad.id,
        estados_globales_id: 1,
        padron_id: participe.padron,
        tipo_de_persona_id: participe.tipo_de_persona,
        sigla_propietario_id: participe.sigla_propietario,
      }));
    });

    if (DEV) {
      form.setFieldValue(
        'result',
        JSON.stringify(predios.map((p) => ({ ...p, colindancias: '', observaciones: '' })), null, 2)
          .concat('\n\n')
          .concat('Errores en predios: ')
          .concat(JSON.stringify(_errors.predios, null, 2))
          .concat(`\n\nTerrenos: ${_errors.terrenos || 'Sin errores'}`)
          .concat(`\nConstrucciones: ${_errors.construcciones || 'Sin errores'}`)
          .concat('\n\n'),
      );
    }
    form.setFieldValue('predios', predios);
    setErrors(_errors);
    setLoading(false);
  };

  useEffect(() => {
    if (!archivo) {
      form.setFieldValue('predios', []);
      form.setFieldValue('result');
      setErrors();
      return;
    }
    const reader = new FileReader();
    reader.onload = async (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = read(data, { type: 'array' });
      parseFile(workbook);
    };
    reader.readAsArrayBuffer(archivo.file);
  }, [archivo]);

  useEffect(() => {
    setTimeout(() => form.setFieldsValue({
      cantidad: _cantidad,
      clonar_direccion: false,
      clonar_participes: false,
      clonar_info_general: false,
      observaciones_subdivision,
      observaciones_cancelacion,
    }));
  }, [tramites]);

  const rules = {
    required: [{ required: true }],
    cantidad: [
      { required: true },
      {
        validator: async (_, val) => {
          if (val && cantidadMaxima && val > cantidadMaxima) {
            throw new Error(`Ingrese un valor menor o igual a ${cantidadMaxima}`);
          }
        },
      },
    ],
  };

  return (
    <Spin spinning={loading} tip="Cargando...">
      {!cargaExcel && (
        <>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              label="Número de lotes nuevos"
              tooltip="Cantidad de lotes a generar"
              name="cantidad"
              rules={rules.cantidad}
              normalize={(v) => toInteger(v)}
            >
              <Input disabled={disabled} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={16}>
            <Form.Item
              label="Observaciones"
              name="observaciones_subdivision"
            >
              <Input disabled={disabled} />
            </Form.Item>
          </Col>
        </>
      )}
      {requierePreguntarHeredarCampos && !disabled && (
        <>
          <Col span={24} />
          <Col xs={24} sm={24} md={8}>
            <Form.Item label="Copiar Dirección" name="clonar_direccion">
              <Select disabled={disabled} trueFalse />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item label="Copiar Participes" name="clonar_participes">
              <Select disabled={disabled} trueFalse />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item label="Copiar Información General" name="clonar_info_general">
              <Select disabled={disabled} trueFalse />
            </Form.Item>
          </Col>
        </>
      )}
      {aplicaObservacionCancelacion && (
        <Col xs={24} sm={24} md={16}>
          <Form.Item
            label="Observaciones"
            name="observaciones_cancelacion"
          >
            <Input disabled={disabled} />
          </Form.Item>
        </Col>
      )}
      {cargaExcel && (
        <>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              label="Cantidad"
              name="cantidad"
              rules={rules.cantidad}
              normalize={(v) => toInteger(v)}
            >
              <Input disabled={disabled || archivo} />
            </Form.Item>
          </Col>
          <Uploader
            title="Archivo"
            formItemName="archivo"
            rules={rules.required}
            allowedExtensions={['xlsx']}
            limitMB={Number.MAX_SAFE_INTEGER}
            disabled={disabled || !cantidad}
          />
        </>
      )}
      {(errors?.terrenos || errors?.construcciones || !!errors?.predios.length) && (
        <Col span={24} style={{ fontWeight: 'bold', fontSize: 16 }}>
          Inconsistencia en los siguiente datos, no se encontraron ids de llaves foráneas
          <ul>
            {errors.predios.length ? errors.predios.map((e) => (
              <li key={e.row}>
                {`Fila ${e.row}: ${e.errors}`}
              </li>
            )) : <li>Sin errores en hoja principal</li>}
            <li>
              Terrenos
              {errors.terrenos && (
                <Tooltip title="Filas con errores, no se pudo encontrar llave foránea de valor">
                  <QuestionCircleOutlined style={{ marginLeft: 3 }} />
                </Tooltip>
              )}
              {`: ${errors.terrenos || 'Sin errores'}`}
            </li>
            <li>
              Construcciones
              {errors.construcciones && (
                <Tooltip title="Filas con errores, no se pudo encontrar llave foránea de valor">
                  <QuestionCircleOutlined style={{ marginLeft: 3 }} />
                </Tooltip>
              )}
              {`: ${errors.construcciones || 'Sin errores'}`}
            </li>
          </ul>
        </Col>
      )}
      {DEV && (
        <Col span={24}>
          <Form.Item name="result">
            <Input.TextArea disabled autoSize={{ minRows: 20 }} />
          </Form.Item>
        </Col>
      )}
      <Form.Item name="predios" hidden><Input.TextArea disabled /></Form.Item>
      {!!tramites.length && (
        <>
          <Col span={24}>
            <Typography.Title level={3}>
              {`Trámites (${tramites.length})`}
            </Typography.Title>
          </Col>
          <Col span={24}>
            <List>
              {tramites.map((tramite) => (
                <ListItem key={tramite.id}>
                  <Typography.Text>
                    {DEV && `(${tramite.id}) `}
                    {/* type={typeByStatusMap[tramite.estados_globales]}
                      delete={tramite.estados_globales === ESTADOS_GLOBALES_MAP.CANCELADO} */}
                    <Link target="_blank" to={`?tramite=${tramite.id}`} style={{ color: 'inherit' }}>
                      {tramite.folio}
                      {' '}
                      <LinkOutlined />
                    </Link>
                  </Typography.Text>
                </ListItem>
              ))}
            </List>
          </Col>
        </>
      )}
    </Spin>
  );
};

const List = styled.ul`
  display: flex;
  flex-direction: row;
  flex-flow: row wrap;
`;

const ListItem = styled.li`
  cursor: pointer;
  width: calc(100% / 3);
  @MEDIA only screen and (max-width: 576px) {
    width: 100%;
  }
  .ant-typography {
  }
`;

export default Subdivision;
